import type {PageRouteConfig} from '@router';

import Invoice from 'modules/Invoice/Invoice';

export function createInvoiceRoute(): PageRouteConfig {
  return {
    element: <Invoice />,
    layout: {
      title: 'جزئیات واریزی',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      resolveLink: (ctx) => `/profile/${ctx.selectedVendor?.id}`
    }
  };
}
